import React from "react";
import { bool } from "prop-types";
import LandingSimpleSection from "./SimpleSection";

const LandingSimpleSectionStripped = ({ isDark = false, ...props }) => {
	return (
		<LandingSimpleSection
			utility={{ bgColor: isDark ? "black--02" : null }}
			isBorderNone
			{...props}
		/>
	);
};

LandingSimpleSectionStripped.propTypes = {
	isDark: bool,
	...LandingSimpleSection.propTypes,
};

export default LandingSimpleSectionStripped;
